module.exports = __webpack_public_path__ + "img/trash-04.6b0f6d33.svg";